import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const UpToDateSection = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: handle submission logic
        alert(`Subscribed with: ${email}`);
        setEmail('');
    };

    return (
        <section className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
                {/* Section Heading */}
                <div className="text-center mb-10 max-w-5xl mx-auto">
                    <h2 className="text-5xl font-bold">{t('uptodate.title')}</h2>
                    <h4 className='text-xl mt-5'>{t('uptodate.subtitle')}</h4>
                </div>

                {/* Subscription Form */}
                <div className="max-w-2xl mx-auto">
                    <form onSubmit={handleSubmit}>
                        <div className="relative w-full">
                            <input
                                type="email"
                                name="EMAIL"
                                placeholder="Email Address..."
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-4 py-3 pr-32 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                                type="submit"
                                className="absolute right-1 top-1 bottom-1 px-6 bg-yellow-500 text-white rounded-full hover:bg-yellow-500 transition"
                            >
                                {t('uptodate.submit')}
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </section>
    );
};

export default UpToDateSection;
